import angular from 'angular';
import _ from 'lodash';
import gridHeight from '../core/shared-service/grid-utils';

class reportsCtrl {
  /* @ngInject */
  constructor($scope, logger, REPORTS, ReportFilter, PrincipalSvc, $state) {
    this.$scope = $scope;
    this.logger = logger;
    this.REPORTS = REPORTS;
    this.ReportFilter = ReportFilter;
    this.PrincipalSvc = PrincipalSvc;
    this.$state = $state;
  }

  $onInit() {
    // Section recherche
    this.reportTypes = this.REPORTS.reports.types;
    this.searchOpen = true;
    this.searchData = new this.ReportFilter();

    var defaultCellTemplate = '<div class="ui-grid-cell-contents">{{COL_FIELD CUSTOM_FILTERS}}</div>';
    var nameTemplate =
      '<div class="ui-grid-cell-contents">' +
      '<span class="col-md-11"><a class="kiss-black-link" href="{{grid.appScope.$ctrl.downloadReportXls(row)}}" target="_blank">{{COL_FIELD CUSTOM_FILTERS}}</a></span>' +
      '<span><a href="{{grid.appScope.$ctrl.downloadReportCsv(row)}}" target="_blank">csv</a></span></div>';
    // Liste
    this.gridOptions = {
      columnDefs: [
        {
          name: 'date',
          displayName: 'principal.reports.col_name.date',
          headerCellFilter: 'translate',
          cellTemplate: defaultCellTemplate,
          cellFilter: "date:'short'",
          width: 200,
          cellClass: 'pointer defaultcursor'
        },
        {
          name: 'getTypeLabel()',
          displayName: 'principal.reports.col_name.type',
          headerCellFilter: 'translate',
          cellTemplate: defaultCellTemplate,
          width: 280,
          cellClass: 'pointer defaultcursor'
        },
        {
          name: 'getXlsFilename()',
          displayName: 'principal.reports.col_name.name',
          headerCellFilter: 'translate',
          cellTemplate: nameTemplate,
          cellClass: 'pointer defaultcursor'
        }
      ],
      useExternalPagination: true,
      useExternalSorting: true,
      onRegisterApi: gridApi => {
        this.gridApi = gridApi;
        // Sorting & pagination
        gridApi.core.on.sortChanged(this.$scope, (grid, sortColumns) => {
          sortColumns = _.map(sortColumns, col => this.convertSort(col));
          if (sortColumns && sortColumns.length > 0) {
            this.searchData.setSort(sortColumns);
          } else {
            this.searchData.resetSort();
          }
          this.search();
        });
        gridApi.pagination.on.paginationChanged(this.$scope, (page, size) => {
          this.searchData.setPageSize(size);
          this.searchData.setPage(page - 1);
          this.search();
        });
      },
      enableSorting: true,
      enableGridMenu: false,
      enableColumnMenus: false,
      enableVerticalScrollbar: false
    };

    this.search();
  }

  convertSort(col) {
    var columnField = _.find(this.REPORTS.reports.columnFieldMap, { field: col.field });
    if (col && col.sort) {
      return {
        direction: angular.uppercase(col.sort.direction),
        property: columnField ? columnField.property : col.field,
        priority: col.sort.priority
      };
    }
    return {};
  }

  search() {
    this.reportsPromise = this.PrincipalSvc.searchReports(this.principal.detail.id, this.searchData);
    this.reportsPromise.then(
      reportData => {
        this.gridOptions.data = reportData.reports;
        this.gridOptions.totalItems = reportData.totalItems;
      },
      function() {
        this.logger.error('error.search');
      }
    );
  }

  clearForm() {
    // Reset data
    this.searchData = new this.ReportFilter();
    // Reset form
    this.form.$setPristine();
    // Recherche
    this.search();
  }

  /**
   * Téléchargement du rapport.
   */

  downloadReportCsv(row) {
    return this.PrincipalSvc.downloadReportFile(row.entity.id, 'CSV');
  }

  /**
   * Téléchargement du rapport.
   */

  downloadReportXls(row) {
    return this.PrincipalSvc.downloadReportFile(row.entity.id, 'XLS');
  }

  /**
   * Fournit la hauteur optimale de la grid en fonction du nombre d'element par page.
   */
  getGridHeight(gridApi) {
    return gridHeight(gridApi);
  }

  backList() {
    this.$state.go('do', { tabName: 'principal' });
  }
}

angular.module('app.principal').component('reports', {
  templateUrl: require('./reports.html'),
  controller: reportsCtrl,
  bindings: {
    principal: '<'
  }
});
